// Disabled links
$(document).on("click", "a[disabled]", function(e) {
	e.preventDefault();
	e.stopPropagation();
	e.stopImmediatePropagation();
});

// Attach dynamic click listeners
$(document).on("click", "[data-trigger=click]", function(e) {

    if ($(this).data()["preventDefault"]) {
        e.preventDefault();
    }

    var params = [];

    if ($(this).attr("data-params")) {
        params = eval("[" + $(this).attr("data-params") + "]");
    }

    params.push(e);

    var controller = eval($(this).attr("data-controller"));
    controller.apply(this, params);
});

//Take first letter from client review name
$('.client-name').each(function(i, el) {
	var name = $(el).data('name');
	var firstName = name.split(' ').slice(0, -1).join(' ');
	var lastName = name.split(' ').slice(-1).join(' ');
    var firstNameLetter = firstName.charAt(0);
	var lastNameLetter = lastName.charAt(0);
    var letterSpaceHolder = $(el).siblings()[0];
    $(letterSpaceHolder).text(firstNameLetter+lastNameLetter);
});

if ($(".client-reference__footer").length) {
    // Photoswipe init        
    $(".client-reference__footer").photoSwipe(
        ".lightbox-container",
        {
            bgOpacity: 0.8,
            shareEl: false,
            captionEl: false,
            tapToClose: true,
			counterEl: false,
        }
    );
}

var beforeNavScroll = null;

$("#nav-trigger").on( "click" , function(e) {
	e.preventDefault();

	var $body = $(document.body);

	if ($body.hasClass("nav-visible")) {
		$body.removeClass("nav-visible");
		$(window).scrollTop(beforeNavScroll);
	}
	else {
		beforeNavScroll = $(window).scrollTop();
		$body.addClass("nav-visible");
	}

});

// mobile toggle 
$(".main-nav__child-toggler").on( "click" , function(e) {
	e.preventDefault();

	var parent = $(this).closest(".main-nav__item--has-childrens");

	parent.toggleClass('main-nav__item--show-childrens');

});

// Floating labels
$(":input").on("focus", function() {

	var group = $(this).closest(".form__group");
	group.addClass("form__group--focused");

});

$(":input").on("blur", function() {
	
	var group = $(this).closest(".form__group");
	group.removeClass("form__group--focused");

});

$(":input").on("change", function() {

	var group = $(this).closest(".form__group");

	if (
		($(this).val() !== null && $(this).val() !== "") ||
	 	$(this).is("select")
	) {
		group.addClass("form__group--filled");
	}
	else {
		group.removeClass("form__group--filled");
	}

}).change();

$(":input").on("input", function() {

	var group = $(this).closest(".form__group");
	var append = group.find(".form__append-fix")

	append.html($(this).val().replace(new RegExp(" ", "g"), "&nbsp;"));

});

